import Typography from '@components/Typography';
import { useDevice } from '@contexts/device';

import { MultiSelectionFilterWrapper } from './MultiSelectionFilterStyle';
import MultiSelectionFilter from './MultiSelectionFilter';
import { MultiSelectionFilterProps } from './types';

const NonCollapsibleMultiSelectionFilter = (
  props: MultiSelectionFilterProps
) => {
  const { title, selectedItems, showSelectedItemsCount, ...rest } = props;

  const { ...multiSelectionFilterProps } = rest;
  const { isDesktop } = useDevice();
  return (
    <MultiSelectionFilterWrapper style={{ paddingBottom: '10px' }}>
      <Typography
        variant='caption1'
        color='NL800'
        weight='Bold'
        style={{ padding: isDesktop ? '0px' : '15px' }}
      >
        {title}
        {showSelectedItemsCount ? (
          <span>({selectedItems.length} Seçildi)</span>
        ) : null}
      </Typography>
      <MultiSelectionFilter
        selectedItems={selectedItems}
        {...multiSelectionFilterProps}
      />
    </MultiSelectionFilterWrapper>
  );
};

export default NonCollapsibleMultiSelectionFilter;
